import React from "react";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import '@/Scss/Site/AboutCompany/index.scss';

const Index = (props) => {
    const {h1} = props;

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <p className={`breadcrumbs__text`}>{h1}</p>
                    </Breadcrumbs>
                    <h1 className={`h1`}>{h1}</h1>
                    <div className={`about-company`}>
                        {/*ВНИМАНИЕ: Для нечетных элементов добавляется класс .reverse */}
                        <div className={`about-company__item reverse`}>
                            <div className={`about-company__img`}>
                                <Picture src={`/storage/img/about-company/img_1.jpg`} alt={`Философия бренда`} />
                            </div>
                            <div className={`about-company__text`}>
                                <p className={`about-company__title`}>Философия бренда</p>
                                <p className={`about-company__description`}>
                                    Наш путь начался очень и&nbsp;очень давно&nbsp;&mdash; миллионы
                                    и&nbsp;миллиарды лет назад, когда создавалась наша Вселенная. Этот огромный,
                                    необъятный и&nbsp;прекрасный мир даёт нам цель и&nbsp;созидает ценности,
                                    которые формируют нас. Каждое существо, каждый объект в&nbsp;этом
                                    мире&nbsp;&mdash; есть захватывающий танец космических частиц, прошедших
                                    сотни и&nbsp;сотни перерождений, проживших тысячи жизней. Каждый из&nbsp;нас
                                    мог быть звездой, частицей или... волной, которая летит сквозь время
                                    и&nbsp;пространство со&nbsp;скоростью света. Мог быть энергией,
                                    из&nbsp;которой возникают звёзды и&nbsp;галактики! И&nbsp;у&nbsp;каждого
                                    из&nbsp;нас&nbsp;&mdash; свой путь.
                                </p>
                                <div className={`about-company__link`}>
                                    <Link href={`/philosophy`} className={`btn btn__white btn__default`}>
                                        Подробнее
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className={`about-company__item`}>
                            <div className={`about-company__img`}>
                                <Picture src={`/storage/img/about-company/img_2.jpg`} alt={`Гарантии качества`} />
                            </div>
                            <div className={`about-company__text`}>
                                <p className={`about-company__title`}>Гарантии качества</p>
                                <p className={`about-company__description`}>
                                    Высокое качество изделий ювелирного бренда PLATINA&nbsp;&mdash; это одно
                                    из&nbsp;конкурентных
                                    преимуществ нашей компании, которое достигается за&nbsp;счет:
                                    &mdash;&nbsp;использования высококачественных лигатурных сплавов, отвечающих
                                    требованиям Российских и&nbsp;Европейских стандартов;
                                    &mdash;&nbsp;проведения многоступенчатого контроля технологического процесса
                                    и&nbsp;качества сырья в&nbsp;собственной лаборатории, оснащенной современным
                                    оборудованием;
                                    &mdash;&nbsp;применения сертифицированных натуральных вставок, которые имеют
                                    документы, подтверждающие легальность их&nbsp;происхождения.
                                </p>
                                <div className={`about-company__link`}>
                                    <Link href={`/quality-guarantee`} className={`btn btn__white btn__default`}>
                                        Подробнее
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className={`about-company__item reverse`}>
                            <div className={`about-company__img`}>
                                <Picture src={`/storage/img/about-company/img_3.jpg`} alt={`Работа в компании`} />
                            </div>
                            <div className={`about-company__text`}>
                                <p className={`about-company__title`}>Работа в компании</p>
                                <p className={`about-company__description`}>
                                    Ювелирный бренд PLATINA приглашает на&nbsp;работу профессионалов. Наша
                                    продукция
                                    выделяется на&nbsp;рынке высочайшим качеством, и&nbsp;поэтому
                                    мы&nbsp;сотрудничаем только с&nbsp;лучшими специалистами! Готовы стать
                                    частью
                                    нашего большого и&nbsp;дружного коллектива? Тогда присылайте ваше резюме
                                    и&nbsp;портфолио!
                                </p>
                                <div className={`about-company__link`}>
                                    <Link href={`/jobs`} className={`btn btn__white btn__default`}>
                                        Смотреть вакансии
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className={`about-company__item`}>
                            <div className={`about-company__img`}>
                                <Picture src={`/storage/img/about-company/img_4.jpg`} alt={`Контакты`} />
                            </div>
                            <div className={`about-company__text`}>
                                <p className={`about-company__title`}>Контакты</p>
                                <p className={`about-company__description`}>
                                    Ювелирный завод &laquo;Платина&raquo;, ИНН 4415004465, ОГРН 1044469011608
                                </p>
                                <p className={`about-company__description`}>
                                    юридический адрес: 157940, Костромская обл., пгт. Красное-на-Волге, ул.
                                    Окружная, дом&nbsp;8
                                </p>
                                <p className={`about-company__description`}>
                                    телефоны: +7 (499) 300-14-07, +7 (49432) 3-10-10, +7 (49432) 3-10-08
                                </p>
                                <p className={`about-company__description`}>
                                    e-mail: office@platina-jewelry.ru
                                </p>
                                <p className={`about-company__description`}>
                                    время работы: с&nbsp;9:00 до&nbsp;17:30 (пн.-пт.)
                                </p>
                                {/*<p className={`about-company__description`}>*/}
                                {/*    телефоны: +7 (49432) 3-10-08, +7 (49432) 3-10-12 e-mail:*/}
                                {/*    office@platina-jewelry.ru время работы: с&nbsp;9:00 до&nbsp;17:30 (пн.-пт.)*/}
                                {/*</p>*/}
                                <div className={`about-company__link`}>
                                    <Link href={`/contacts`}
                                          className={`btn btn__white btn__default`}>
                                        Еще контакты
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
}

export default Index;
